import { heroStats } from "@/mocks/home";

export default function Standfirst() {
  return (
    <section className="w-full border-b border-foreground-900/10 bg-background-50">
      <div className="mx-auto w-full max-w-[1360px] px-4 py-16 md:px-8 md:py-24">
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-xs tracking-[0.34em] text-foreground-500">卷首 · 说明</p>
          <p className="mt-7 font-heading text-xl leading-relaxed text-foreground-900 md:text-2xl">
            「吃瓜爆黑料」并不是某一个单独的账号，而是一堆分散在各处的主页、频道与合集。
            这一页把它们收进一本能按顺序翻的导航册——先看哪一本、由谁更新、到哪儿补回放，
            都写在明面上。
          </p>
          <p className="mt-6 text-sm leading-relaxed text-foreground-600">
            全部内容仅为公开入口的整理与导航，不生产、不搬运原始素材。
          </p>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-foreground-900/10 bg-foreground-900/10 lg:grid-cols-4">
          {heroStats.map((stat) => (
            <div key={stat.id} className="bg-background-50 px-5 py-8 text-center">
              <p className="font-heading text-3xl font-bold text-primary-600 md:text-4xl">
                {stat.value}
              </p>
              <p className="mt-2 text-xs tracking-wider text-foreground-600 md:text-sm">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}